<template>
  <form :novalidate="true" @submit.prevent="submit">
    <b-field grouped group-multiline class="columns">
      <b-field
        label="*Nom"
        :message="fields.name.error"
        :type="{ 'is-danger': fields.name.error }"
        class="column is-full-mobile"
      >
        <b-input
          v-model="fields.name.value"
          expanded
          placeholder="Nom du lien"
          type="text"
          :icon-right="fields.name.value ? 'close-circle' : ''"
          :icon-right-clickable="!!fields.name.value"
          @icon-right-click="fields.name.value = null"
        />
      </b-field>
      <b-field
        label="*Url"
        :message="fields.url.error"
        :type="{ 'is-danger': fields.url.error }"
        class="column is-full-mobile"
      >
        <b-input
          v-model="fields.url.value"
          expanded
          placeholder="https://example.com"
          type="url"
          :icon-right="fields.url.value ? 'close-circle' : ''"
          :icon-right-clickable="!!fields.url.value"
          @icon-right-click="fields.url.value = null"
        />
      </b-field>
      <b-field
        label="*Icône"
        :message="fields.icon.error"
        :type="fields.icon.error !== null ? 'is-danger' : ''"
        class="column is-full-mobile"
      >
        <o-icon-picker
          v-model="fields.icon.value"
          :icons="icons"
          placeholder="Rechercher une icône"
        />
      </b-field>
    </b-field>
    <b-field>
      <b-button
        native-type="submit"
        type="is-primary"
        :loading="loading"
        :disabled="isFormInvalid"
        label="Ajouter"
      />
    </b-field>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { isURL } from '@helpers/isURL'
import { iconNames } from '@data/icons'
import OIconPicker from '@components/IconPicker.vue'

export default {
  name: 'LiveAddExternalLinkForm',

  components: {
    OIconPicker,
  },

  props: {
    liveId: {
      type: String,
      required: true,
    },
    position: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
      fields: {
        url: {
          value: null,
          error: null,
        },
        name: {
          value: null,
          error: null,
        },
        icon: {
          value: null,
          error: null,
        },
      },
    }
  },

  created() {
    this.icons = iconNames
  },

  watch: {
    'fields.url.value'(url) {
      this.fields.url.error = url && url.length > 0 && !isURL(url) ? 'Url incorrect' : null
    },
  },

  computed: {
    isFormInvalid() {
      return (
        Object.values(this.fields).find((field) => field.error !== null || field.value === null) ||
        this.loading
      )
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit() {
      this.loading = true

      try {
        const createdLiveExternalLink = await this.$services.liveExternalLinkService.create({
          liveId: this.liveId,
          url: this.fields.url.value,
          name: this.fields.name.value,
          icon: this.fields.icon.value,
          position: this.position,
        })

        this.resetFields()
        this.$emit('submit', createdLiveExternalLink)

        this.addToastMessage({
          text: 'Le lien a été créé.',
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
      }

      this.loading = false
    },

    resetFields() {
      Object.values(this.fields).forEach((field) => {
        field.value = null
        field.error = null
      })
    },
  },
}
</script>
